export enum TimelineItemTypesEnum {
  NOTE = 1,
  HISTORY = 2
}
